import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MyMenu from "./MyMenu";

const IconMenu = ({ row, onAction }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleIconClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label="Actions"
        aria-controls={`menu-${row?.marketerUserEmail || row?.id}`}
        aria-haspopup="true"
        onClick={handleIconClick}
      >
        <MoreVertIcon />
      </IconButton>
      <MyMenu
        id={`menu-${row?.marketerUserEmail || row?.id}`}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        row={row}
        onAction={onAction}
      />
    </>
  );
};

export default IconMenu;
